module.exports = function(bootstrap) {
    bootstrap.directive('upmc', function () {
       return {
           restrict: 'A',
           scope: false,
           replace: true,
           template: require('articles/providers/UPMC/UPMC.html'),
           controller: ['$scope', '$state', function ($scope, $state) {
               $scope.page = $state.params.page;
           }]
       };
    });
};